import type { Positionable } from './ListEdgeDetails.tsx';
import { subtract } from './percentageOfLine.tsx';
import type { Point } from './toPortInfo.tsx';
import type { DragDropState } from './useCanvasDragDropEvents.tsx';

export const getDraggingItem = (
	dragDropState: DragDropState,
	positionOverride?: Point,
): Positionable | undefined => {
	if (
		!dragDropState ||
		!dragDropState.isDragging ||
		(dragDropState.dragSubject.type !== 'status' &&
			dragDropState.dragSubject.type !== 'start-node' &&
			dragDropState.dragSubject.type !== 'global-loops-container')
	) {
		return;
	}

	return {
		type: dragDropState.dragSubject.type,
		id: dragDropState.dragSubject.id,
		position:
			positionOverride || subtract(dragDropState.currentPosition, dragDropState.dragSubject.offset),
	};
};
